import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';

type Options = {
  onEnterBalance: () => void;
};

export function useTabState({ onEnterBalance }: Options) {
  const store = useLocalObservable(() => ({
    activeTab: 0,
  }));

  function setActiveTab(tab: number) {
    runInAction(() => {
      store.activeTab = tab;
    });
    if (tab === 3) onEnterBalance();
  }

  return {
    store,
    setActiveTab,
    get activeTab() {
      return store.activeTab;
    },
  };
}

export type TabState = ReturnType<typeof useTabState>;
